import React from 'react';
import { Create, useRedirect, useDataProvider } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { EstimateWizard } from '../../components/EstimateWizard';

interface EstimateData {
  id?: string;
  estimateNumber: string;
  customerId: string;
  title: string;
  issueDate: Date;
  validUntil: Date;
  lineItems: unknown[];
  notes?: string;
  terms?: string;
  status: 'draft' | 'sent' | 'approved' | 'rejected' | 'expired';
}

export const EstimateCreate = () => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(false);

  // Extract customerId from URL parameters
  const searchParams = new URLSearchParams(location.search);
  const customerId = searchParams.get('customerId');

  const handleSave = async (data: EstimateData, _action: 'draft' | 'send') => {
    try {
      setIsLoading(true);
      console.log('EstimateCreate: Calling dataProvider.create with data:', data);
      const result = await dataProvider.create('estimates', { data });
      console.log('EstimateCreate: Result from dataProvider.create:', result);
      console.log('EstimateCreate: Result.data:', result?.data);
      console.log('EstimateCreate: Result.data?.id:', result?.data?.id);
      
      if (!result || !result.data || !result.data.id) {
        console.error('EstimateCreate: Validation failed - result:', result);
        throw new Error('Failed to create estimate: No data returned');
      }
      
      // Return in the format expected by EstimateWizard: { data: {...} }
      return result;
    } catch (error: any) {
      console.error('EstimateCreate: Error in handleSave:', error);
      console.error('EstimateCreate: Error details:', {
        message: error.message,
        status: error.status,
        body: error.body,
        stack: error.stack,
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const handleComplete = (estimateId: string) => {
    redirect('show', 'estimates', estimateId);
  };

  return (
    <Create title="Create Estimate" redirect={false}>
      <EstimateWizard
        onSave={handleSave}
        onComplete={handleComplete}
        isLoading={isLoading}
        preselectedCustomerId={customerId || undefined}
      />
    </Create>
  );
};
